<div class="flex flex-col border border-primary-600">
  <div class="flex flex-row justify-between bg-primary-600 p-4">
    <div class="bg-primary-600 text-white rounded-tl-md">{{ { key: 'place', n: 1 } | i18n }}</div>
    <div class="bg-primary-600 text-white rounded-tr-md">{{ { key: 'hour' } | i18n }}</div>
  </div>

  @for (row of rows(); track row._id) {
    <div class="flex flex-row justify-between p-4 hover:bg-opacity-10 hover:bg-primary-600">
      <div>{{ row.name | i18n }}</div>
      <div>{{ row.credits | number: '1.2-2' }}</div>
    </div>
  }
</div>
